import React from "react";
import swal from "sweetalert";
import Survey from "./Survey";
import { withTranslation } from "react-i18next";
import { Languages, MAX_COMMENT_LENGTH } from "../utils/Config";
import { QuestionTags } from "../utils/Questions";
import { redirectToBrandWebsiteByGroup } from "../utils/country/CountryManager";
import { getGroup } from "../utils/ApiManager";
import { isRequiredField } from "../utils/Questions";
import moment from "moment-timezone";

class SurveyContainer extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			ticketId: undefined,
			lang: Languages.ENGLISH,
			[QuestionTags.FIRST]: "",
			[QuestionTags.SECOND]: "",
			[QuestionTags.THIRD]: "",
			[QuestionTags.FOURTH]: "",
			[QuestionTags.FIFTH]: "",
			[QuestionTags.SIXTH]: "",
			isValidComment: true,
			loading: false,
			recentlyAnswered: false,
		};
		this.handleOptionChange = this.handleOptionChange.bind(this);
		this.handleCommentChange = this.handleCommentChange.bind(this);
		this.sendSurvey = this.sendSurvey.bind(this);
	}

	handleOptionChange(changeEvent) {
		const selection = changeEvent.target;
		const tag = selection.id.split("-")[0];
		this.setState({
			[tag]: selection.getAttribute("data-option"),
		});
	}

	handleCommentChange(changeEvent) {
		let { value } = changeEvent.target;
		this.setState({
			...this.state,
			[QuestionTags.SIXTH]: value,
			isValidComment: value.length <= MAX_COMMENT_LENGTH,
		});
	}

	onSuccess = (t) => {
		this.setState({
			...this.state,
			loading: false,
			recentlyAnswered: true,
		});
		swal({
			title: t("pop-up.success.title"),
			text: t("pop-up.success.description"),
			icon: "success",
			button: t("pop-up.button-text"),
		}).then((value) => this.redirectToBrandPage());
	};

	onFailure = (t, error) => {
		console.log("Error: " + error);
		setTimeout(this.setState({ ...this.state, loading: false, error: error }), 1000);
		swal({
			title: t("pop-up.error.title"),
			text: `${t("pop-up.error.description").replace("%ERROR%", error.message)}`,
			icon: "error",
			button: t("pop-up.button-text"),
		});
	};

	areEmptyFields() {
		const emptyFields = [];
		console.log(this.state);
		for (const tag of Object.values(QuestionTags)) {
			if (!this.state[tag] && isRequiredField(tag)) {
				emptyFields.push(tag);
			}
		}
		this.setState({
			...this.state,
			emptyFields: emptyFields,
		});
		return emptyFields.length !== 0;
	}

	surveyToZendeskJson() {
		const csat = this.state[QuestionTags.FIRST];
		const time = this.state[QuestionTags.SECOND];
		const ces = this.state[QuestionTags.THIRD];
		const firstContact = this.state[QuestionTags.FOURTH];
		const nps = this.state[QuestionTags.FIFTH];
		const comment = this.state[QuestionTags.SIXTH];
		const url = `https://holastanley.zendesk.com/agent/tickets/${this.props.ticketId}`;
		const surveyJson = {
			ticket: {
				custom_fields: [
					{
						_title: "Dropdown 'answered survey'",
						id: 360040189894,
						value: "quality_survey_answered",
					},
					{
						_title: "Survey: 1st Question CSAT - Text",
						id: 360008968358,
						value: csat,
					},
					{
						_title: "Survey: 1st Question CSAT",
						id: 360007692297,
						value: csat,
					},
					{
						_title: "Survey: 2nd Question TIME",
						// id: 360007692317,
						id: 360008969438,
						value: time,
					},
					{
						_title: "Survey: 3rd Question CES",
						// id: 360007687418,
						id: 360008978877,
						value: ces,
					},
					{
						_title: "Survey: 4th Question FIRST CONTACT RESOLUTION",
						// id: 360007793778,
						id: 360008978897,
						value: firstContact,
					},
					{
						_title: "Survey: 5th Question NPS",
						// id: 360007691577,
						id: 360008979057,
						value: nps,
					},
					{
						_title: "Survey: 6th Question OPEN COMMENT",
						id: 360007794378,
						value: comment,
					},
					{
						_title: "Survey: Answer Date",
						id: 360041632891,
						value: moment().tz("America/New_York").format("LLL"),
					},
					{
						_title: "Ticket URL",
						id: 360010674337,
						value: url,
					},
				],
			},
		};
		return surveyJson;
	}

	isBadRating() {
		const csat = this.state[QuestionTags.FIRST];
		const time = this.state[QuestionTags.SECOND];
		const ces = this.state[QuestionTags.THIRD];
		const firstContact = this.state[QuestionTags.FOURTH];
		const nps = this.state[QuestionTags.FIFTH];
		if (csat <= 2 || time <= 2 || ces <= 2 || firstContact === 0 || nps <= 6) {
			console.log("Se encontró una mala calificación");
			return true;
		}
		return false;
	}

	//https://holastanley.zendesk.com/agent/admin/triggers/360038030078
	async sendUsingApi(surveyJson) {
		const { t } = this.props;
		await fetch(`https://holastanley.zendesk.com/api/v2/tickets/${this.props.ticketId}.json`, {
			method: "PUT",
			body: JSON.stringify(surveyJson),
			headers: {
				Authorization: "Bearer c37245862ac78f98fd1b5ba50a6cd7d3c954aa81a10ebb35b8bc7f8a23c756c3",
				"Content-Type": "application/json",
			},
		})
			.then((res) => {})
			.then((res) => {
				this.onSuccess(t);
				console.log("Closed");
			})
			.catch((error) => this.onFailure(t, error));

		const tags = ["survey_answered"];
		if (this.isBadRating()) {
			tags.push("bad_rating_in_survey");
		}
		await fetch(`https:///holastanley.zendesk.com/api/v2/tickets/update_many.json?ids=${this.props.ticketId}`, {
			method: "PUT",
			body: JSON.stringify({ ticket: { additional_tags: tags } }),
			headers: {
				Authorization: "Bearer c37245862ac78f98fd1b5ba50a6cd7d3c954aa81a10ebb35b8bc7f8a23c756c3",
				"Content-Type": "application/json",
			},
		})
			.then((res) => {})
			.then((res) => {
				this.onSuccess(t);
				console.log("Bad rating");
			})
			.catch((error) => this.onFailure(t, error));
	}

	async redirectToBrandPage() {
		let group = await getGroup(this.props.groupId);
		if (group !== null && group !== undefined) group = group.group.name;
		redirectToBrandWebsiteByGroup(group, this.props.brand);
	}

	sendSurvey(e, t) {
		e.preventDefault();
		if (!this.props.isValidUrl) {
			swal({
				title: t("pop-up.invalid-link.title"),
				text: t("pop-up.invalid-link.description"),
				icon: "error",
				button: t("pop-up.button-text"),
			});
			return;
		}

		if (this.props.surveyHasAnswer || this.state.recentlyAnswered) {
			swal({
				title: t("pop-up.survey-has-answer.title"),
				text: t("pop-up.survey-has-answer.description"),
				icon: "error",
				button: t("pop-up.button-text"),
			});
			return;
		}

		if (this.areEmptyFields()) {
			swal({
				title: t("pop-up.empty-fields.title"),
				text: t("pop-up.empty-fields.description"),
				icon: "error",
				button: t("pop-up.button-text"),
			});
			return;
		}

		if (!this.state.isValidComment) {
			swal({
				title: t("pop-up.error.title"),
				text: t("invalid-comment"),
				icon: "error",
				button: t("pop-up.button-text"),
			});
			return;
		}

		this.setState({ ...this.state, loading: true });
		const surveyJson = this.surveyToZendeskJson();
		this.sendUsingApi(surveyJson);
	}

	render() {
		const { t } = this.props;
		return (
			<Survey
				customerName={this.props.customerName}
				handleOptionChange={this.handleOptionChange}
				handleCommentChange={this.handleCommentChange}
				sendSurvey={(e) => this.sendSurvey(e, t)}
				survey={this.state}
			/>
		);
	}
}
export default withTranslation()(SurveyContainer);
